import { AfterViewInit, Component, ElementRef, inject, Input, OnDestroy, signal } from '@angular/core';

@Component({
  selector: 'app-section-heading',
  standalone: true,
  templateUrl: './section-heading.component.html',
  styleUrl: './section-heading.component.css'
})
export class SectionHeadingComponent implements AfterViewInit, OnDestroy {
  private readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);

  @Input() eyebrow = '';
  @Input() title = '';
  @Input() text = '';
  @Input() align: 'left' | 'center' = 'left';
  @Input() animateTitle = false;
  @Input() animateTitleTrigger: 'immediate' | 'in-view' = 'immediate';

  protected readonly titleAnimationActive = signal(false);
  private titleObserver?: IntersectionObserver;

  ngAfterViewInit(): void {
    if (!this.animateTitle) {
      return;
    }

    if (this.animateTitleTrigger === 'immediate') {
      this.titleAnimationActive.set(true);
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      this.titleAnimationActive.set(true);
      return;
    }

    this.titleObserver = new IntersectionObserver((entries) => {
      const hasIntersected = entries.some((entry) => entry.isIntersecting);

      if (!hasIntersected) {
        return;
      }

      this.titleAnimationActive.set(true);
      this.disconnectTitleObserver();
    }, {
      threshold: 0.25
    });

    this.titleObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.disconnectTitleObserver();
  }

  private disconnectTitleObserver(): void {
    this.titleObserver?.disconnect();
    this.titleObserver = undefined;
  }
}

